import React, { useState } from 'react';
import { Input, Button, Alert } from 'reactstrap';
import { CustomLoading } from './LoadingComponent';
import { getPresignedUrl } from '../redux/ActionCreators';
import { mimetypes } from  '../shared/data';

export const S3Uploader = (props) => {
  const [file, setFile] = useState(null);
  const [loadingFile, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    typeof selectedFile==='undefined' ? setMsg('No se ha seleccionado archivo.') : setMsg('Archivo seleccionado!');
  };

  const uploadFile = async () => {
    if (!file) {
      setMsg('No se ha seleccionado archivo.');
      console.error('File is missing.');
      return;
    }
    setLoading(true);
    try {
      // 1. Get presigned url
      const url = await getPresignedUrl({
        bucket:props.bucket, 
        key:props.dir + file.name, 
        include_content_type:true});
      console.log(url);

      await fetch(url, {
        method: 'PUT',
        headers: {'Content-Type': mimetypes[file.name.split('.')[1]]},
        body: file,
      });


      await fetch(url, {
        method: 'PUT',
        body: file,
      });
    } catch (error) {
      console.error('Error uploading file:', error);
      setLoading(false);    
      setMsg(error.message);
      return
    }
      
    try {
      const resp_val = await props.validator({
        bucket: props.bucket, 
        key: props.dir + file.name,
        ...props.other_params
      });
      if (resp_val.status=='ok'){
        setMsg(resp_val.msg);
        props.changeModel(props.filename_var, file.name);
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      setLoading(false);
      setMsg(error.message);
    }
    setLoading(false);
  };

  return (
    <>
      <div className='row justify-content-start align-items-end'>
        <div className='col-12 file-upload'>
          <img src={require('../shared/upload_file.png')} alt="upload" />
          <h5>Seleccionar archivo</h5>
          <Input
            className="form-control"
            id="inputFile"
            type="file"
            onChange={handleFileChange} 
          />
        </div>
      </div>
      <div className="row m-3 justify-content-center">
        <div className="col">
          <Alert
            color='secondary'
            isOpen={msg!=='' && msg!==null} 
            toggle={()=>setMsg(null)}>
              {msg}
          </Alert>
        </div>
      </div>
      <div className='row justify-content-center align-items-end'>
        <div className='col-12 mt-3'>
          {loadingFile ?
            <CustomLoading msg="guardando portafolios..."/>
          :
            <Button className="btn-corp" onClick={uploadFile}>
              <small>{props.button_label || "Cargar"} &uarr;</small>
            </Button>
          }
        </div>
      </div>
    </>
  );
};
